import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Stock } from '@stockcare-storage/stock/stock';

@Component({
  standalone: false,
  selector: 'app-material-card',
  templateUrl: './material-card.component.html',
  styleUrls: ['./material-card.component.scss']
})
export class MaterialCardComponent implements OnInit {
  @Input() stock: Stock;
  @Output() stockClicked = new EventEmitter<Stock>();

  constructor() {}

  ngOnInit() {}

  cardClicked() {
    this.stockClicked.emit(this.stock);
  }
}
